<template>
	<div class="page-properties" ref="page_properties">
		<BlockFiltersModal
			:data="DataFiltersModal"
			:filtrationInProgress="filtrationInProgress"
			:isFilterHidden="filtrationInProgress"
			@startFiltration="startFiltration"
			@resetFiltration="resetFiltration"
		/>
		<div class="dashborad-properies-wrap">
			<div class="dashborad-properies-wrap-title">
				<div class="dashborad-properies-wrap-title-box">
					<div style="display:flex; justify-content: flex-start;"><h1 class="section-title section-title--dashborad-properies">Properties</h1>
					<div class="dashboard-properties-btn-wrap">
						<router-link class="btn btn--mid btn--icon" id="new_property-button"  :to="{ name: 'NewProperty' }">
							<SvgIcon class="dashborad-properies-wrap__icon-plus" iconName="ico-plus"/>
							<span>Add New</span>
						</router-link>
					</div></div>
					<button class="btn btn--mid btn--icon" v-on:click="exportCSV()">Export</button>
				</div>
				<div class="notification-wrap-center">
					<PartNotifications :data="notificationsData" v-if="notificationsData.msg" />
				</div>
			</div>
			<div class="dashboard-properties-wrap__header">
				<router-link class="dashboard-properties-wrap__header-link is-active-link" id="published_property-button" :to="{ name: 'Properties' }">
					<SvgIcon class="dashboard-properties-wrap__icon dashboard-properties-wrap__icon--list" iconName="ico-clipboard-list"/>
					<span class="dashboard-properties-wrap__header-inner">
						<span>Published Properties </span>
						<span>(<span>{{ allTotals ? allTotals.total_active : 0 }}</span>)</span>
					</span>
				</router-link>
				<router-link class="dashboard-properties-wrap__header-link" id="draft_property-button" :to="{ name: 'DraftProperties' }">
					<SvgIcon class="dashboard-properties-wrap__icon" iconName="ico-pen"/>
					<span class="dashboard-properties-wrap__header-inner">
						<span>Draft Properties </span>
						<span>(<span>{{ allTotals ? allTotals.total_draft : 0 }}</span>)</span>
					</span>
				</router-link>
				<router-link class="dashboard-properties-wrap__header-link" id="trash_property-button" :to="{ name: 'DeletedProperties' }">
					<SvgIcon class="dashboard-properties-wrap__icon" iconName="ico-trash"/>
					<span class="dashboard-properties-wrap__header-inner">
						<span>Deleted Properties </span>
						<span>(<span>{{ allTotals ? allTotals.total_deleted : 0 }}</span>)</span>
					</span>
				</router-link>
			</div>
			<div class="table-wrap" :class="{'table-empty': noResults}">
				<BlockTable
					v-if="!noResults"
					:data="DashboardPropertiesData"
					class="dashborad-properies-table extended-table"
					@deleteRow="deleteRow"
					@historyRow="historyRow"
					@editRow="editRow"
					@sortData="sortProperties"
					@PropertyHistoryOrEdit="PropertyHistoryOrEdit"
					@cloneProperty="cloneProperty"
					:sort="localOrderBy"
					:order="localOrder === 'desc'"
					@getPage="getPage"
				/>

				<PartLoaderBig class="loader-table" v-if="preloader"/>
				<PartNoResults :data="DataNoResults" v-if="noResults && !preloader"/>
				<!-- <PartPagination
					ref="pagination"
					v-show="!preloader && showPagination"
					@getPage="getPage"
				/> -->
			</div>
		</div>
		<PartPopupDelete
			v-if="showPopupDelete"
			:data="PopupDelete"
			@confirmPopupDelete="confirmPopupDelete"
			@closePopupDelete="closePopupDelete"
		>
			<template v-slot:popupTitle>Are you sure you want to delete this property?</template>
			<template v-slot:popupCancel>No</template>
			<template v-slot:popupConfirm>Yes</template>
		</PartPopupDelete>
		<BlockPopupPropertyHistory
			v-if="showPopupTable"
			:data="DataPopupPropertyHistory"
			@closePopupPropertyHistory="closePopupPropertyHistory"
			@updateHistoryTable="updateHistoryTable"
		/>
	</div>
</template>
<script>
import SvgIcon from '@/components/base/SvgIcon/SvgIcon';
import BlockTable from '@/components/blocks/BlockTable';
import PartPopupDelete from '@/components/parts/PartPopupDelete';
// import PartPagination from '@/components/parts/PartPagination';
import PartNotifications from '@/components/parts/PartNotifications';
import BlockPopupPropertyHistory from '@/components/blocks/Admin/Properties/BlockPopupPropertyHistory';
import PartNoResults from '@/components/parts/PartNoResults';
import PartLoaderBig from '@/components/parts/PartLoaderBig';
import BlockFiltersModal from '@/components/blocks/BlockFiltersModal';
import { check } from '@/services/RouteGuards/Admin';

export default {
	data: () => {
		return {
			initialRequestStart: false,
			infinitScrollFlag: false,
			preventGetPage: false,
			filtrationInProgress: false,
			DataNoResults: {},
			noResults: true,
			filter: {},
			notificationsData: {
				type: '',
				msg: ''
			},
			// showPagination: false,
			preloader: true,
			localOrder: 'desc',
			localOrderBy: 'date_listed',
			defaultOrder: 'desc',
			defaultOrderBy: 'date_listed',
			PopupDelete: {
				itemID: ''
			},
			showPopupDelete: false,
			classScroll: 'prevent-scroll',
			DashboardPropertiesData: {
				stickyHeader: true,
				// noLocalSorting: true,
				noCollapse: false,
				sortable: true,
				tableClass: 'text-nowrap',
				defaultOrderBy: 'date_listed',
				fields: [
					{ key: 'title', label: 'Name', sortable: true, stickyColumn: true, variant: 'property thead-lg' },
					{ key: 'offering_type_label', label: 'Offering Type', sortable: true, stickyColumn: true, variant: 'listing-status' },
					{ key: 'area', label: 'Area', sortable: true, stickyColumn: true, variant: 'area' },
					{ key: 'property_type', label: 'Type', sortable: true, stickyColumn: true, variant: 'type' },
					{ key: 'building_size', label: 'Building Size', sortable: true, stickyColumn: true, variant: 'building-size' },
					{ key: 'lot_size', label: 'Lot Size', sortable: true, stickyColumn: true, variant: 'lot-size' },
					{ key: 'regular_price', label: 'Price', sortable: true, stickyColumn: true, variant: 'price' },
					{ key: 'price_buildable_sf', label: 'Price per Buildable SF', sortable: true, stickyColumn: true, variant: 'price-buildable-sf' },
					{ key: 'price_psf', label: 'Price per SF', sortable: true, stickyColumn: true, variant: 'price-psf' },
					{ key: 'lease_price', label: 'Lease Price', sortable: true, stickyColumn: true, variant: 'lease-price' },
					{ key: 'yearly_price', label: 'Yearly Price per SF', sortable: true, stickyColumn: true, variant: 'yearly-price' },
					{ key: 'listing_status_label', label: 'Listing Status', sortable: true, stickyColumn: true, variant: 'listing-status' },
					{ key: 'listing_type_label', label: 'Listing Type', sortable: true, stickyColumn: true, variant: 'listing-type' },
					{ key: 'date_listed', label: 'Date Listed', sortable: true, stickyColumn: true, variant: 'date-added' },
					{ key: 'date_verified', label: 'Date Verified', sortable: true, stickyColumn: true, variant: 'date-verified' },
					{ key: 'lead_source', label: 'Source', sortable: true, stickyColumn: true, variant: 'date-source' },
					{ key: 'agent_name', label: 'Agent', sortable: true, stickyColumn: true, variant: 'agent' },
					{ key: 'clone_property', label: '', sortable: false, stickyColumn: true, variant: 'fixed-icon fourth-icon-fixed' },
					{ key: 'history', label: '', sortable: false, stickyColumn: true, variant: 'fixed-icon third-icon-fixed' },
					{ key: 'delete', label: '', sortable: false, stickyColumn: true, variant: 'fixed-icon second-icon-fixed table-fixed-icon--red last-icon-fixed' },
					{ key: 'edit', label: '', sortable: false, stickyColumn: true, variant: 'fixed-icon first-icon-fixed' }
				],
				items: []
			},
			showPopupTable: false,
			DataPopupPropertyHistory: {
				popupTitle: 'Property History',
				propertyName: '',
				propertyCreated: '',
				DataMatchCustomer: {
					stickyHeader: true,
					noCollapse: false,
					noLocalSorting: false,
					tableClass: 'text-nowrap',
					fields: [
						{ key: 'type', label: 'Type', sortable: true, stickyColumn: true, variant: 'property' },
						{ key: 'from', label: 'Old value', sortable: true, stickyColumn: true, variant: 'type' },
						{ key: 'to', label: 'New value', sortable: true, stickyColumn: true, variant: 'type' },
						{ key: 'updated_at', label: 'Date updated', sortable: true, stickyColumn: true, variant: 'date-updated', thClass: 'th-history' },
						{ key: 'delete_history', label: '', sortable: false, stickyColumn: true, variant: 'fixed-icon first-icon-fixed table-fixed-icon--red last-icon-fixed' }
					],
					items: []
				}
			},
			DataFiltersModal: {
				isCustomer: false,
				DataListingStatus: {
					label: 'Listing Status:',
					labelId: 'radio-listing-status-label',
					id: 'radio-listing-status-input',
					lists: [],
					mandatoryFiled: false,
					options: [],
					multiple: true
				},
				DataYearlyPrice: {
					label: 'Yearly Price per Square Foot',
					classinput: '',
					inputIdMin: 'yearly_price-commercial-input-min',
					inputIdMax: 'yearly_price-commercial-input-max',
					labelId: 'yearly_price-customer-label',
					iconName: 'ico-dollar-sign',
					classIcon: 'input-icon-box',
					currency: true,
					flag: 'yearly_price'
				},
				DataListingType: {
					label: 'Listing Type:',
					labelId: 'radio-listing-type-label',
					id: 'radio-listing-type-input',
					lists: []
				},
				DataDateListed: {
					inputId: 'date_listed-commercial-input',
					labelId: 'date_listed-commercial-label',
					flag: 'date_listed',
					mandatoryFiled: false,
					today: ''
				},
				DataDateVerified: {
					inputId: 'date_verified-commercial-input',
					labelId: 'date_verified-commercial-label',
					flag: 'date_verified',
					mandatoryFiled: false,
					today: ''
				},
				DataInputSearch: {
					inputId: 'commercial-search-input',
					label: 'Search',
					labelId: 'commercial-search-label',
					placeholder: 'Search...',
					searchClass: 'customers-search',
					type: 'text'
				},
				DataOfferingType: {
					label: 'Offering Type',
					labelId: 'offering-type-commercial-label',
					inputId: 'offering-type-commercial-input',
					placeholder: 'Add Type',
					mandatoryFiled: false,
					options: [],
					multiple: true
				},
				DataArea: {
					label: 'Area',
					labelId: 'area-commercial-label',
					inputId: 'area-commercial-input',
					mandatoryFiled: false,
					placeholder: 'Add Area',
					options: [],
					multiple: true
				},
				DataPropertyType: {
					label: 'Property Type',
					labelId: 'type-commercial-label',
					inputId: 'type-commercial-input',
					placeholder: 'Add Type',
					mandatoryFiled: false,
					options: [],
					multiple: true
				},
				DataAssignedAgent: {
					label: 'Assigned Agent',
					labelId: 'user-commercial-label',
					inputId: 'user-commercial-input',
					placeholder: 'Add Agent',
					mandatoryFiled: false,
					options: [],
					multiple: true
				},
				DataBuildingSize: {
					labelId: 'building-size-commercial-label',
					inputIdMin: 'building-size-commercial-input-min',
					inputIdMax: 'building-size-commercial-input-max',
					label: 'Building Size',
					iconName: 'ico-buildings',
					classIcon: 'input-icon-box input-icon-box--big',
					flag: 'building_size'
				},
				DataLotSize: {
					labelId: 'lot-size-commercial-label',
					inputIdMin: 'lot-size-commercial-input-min',
					inputIdMax: 'lot-size-commercial-input-max',
					label: 'Lot Size',
					iconName: 'ico-buildings',
					classIcon: 'input-icon-box input-icon-box--big',
					flag: 'lot_size'
				},
				DataPrice: {
					labelId: 'price-commercial-label',
					inputIdMin: 'price-commercial-input-min',
					inputIdMax: 'price-commercial-input-max',
					label: 'Price',
					iconName: 'ico-dollar-sign',
					classIcon: 'input-icon-box',
					flag: 'price',
					currency: true
				},
				DataPriceBuildableSquareFoot: {
					labelId: 'price-buildable-sf-commercial-label',
					inputIdMin: 'price-buildable-sf-commercial-input-min',
					inputIdMax: 'price-buildable-sf-commercial-input-max',
					label: 'Price per Buildable Square Foot',
					iconName: 'ico-dollar-sign',
					classIcon: 'input-icon-box',
					flag: 'price_buildable_sf',
					currency: true
				},
				DataPriceSquareFoot: {
					labelId: 'price-per-sf-commercial-label',
					inputIdMin: 'price-per-sf-commercial-input-min',
					inputIdMax: 'price-per-sf-commercial-input-max',
					label: 'Price per Square Foot',
					iconName: 'ico-dollar-sign',
					classIcon: 'input-icon-box',
					flag: 'price_psf',
					currency: true
				},
				DataLeasePrice: {
					labelId: 'lease_price-commercial-label',
					inputIdMin: 'lease_price-commercial-input-min',
					inputIdMax: 'lease_price-commercial-input-max',
					label: 'Lease Price',
					iconName: 'ico-dollar-sign',
					classIcon: 'input-icon-box',
					flag: 'lease_price',
					currency: true
				},
				DataNeighborhood: {
					type: 'text',
					inputId: 'neighborhood-input',
					placeholder: 'Neighborhood',
					label: 'Neighborhood',
					labelId: 'neighborhood-label',
					searchClass: 'customers-search'
				},
				DataSource: {
					type: 'text',
					inputId: 'lead_source-input',
					placeholder: 'Lead Source',
					label: 'Lead Source',
					labelId: 'lead_source-label',
					searchClass: 'customers-search'
				}
			}
		};
	},
	components: {
		BlockTable,
		SvgIcon,
		PartPopupDelete,
		PartLoaderBig,
		// PartPagination,
		PartNotifications,
		PartNoResults,
		BlockPopupPropertyHistory,
		BlockFiltersModal
	},
	created() {
		const user = JSON.parse(localStorage.getItem('user'));
		if (localStorage.getItem('filter-property') && JSON.parse(localStorage.getItem('filter-property')).user_id === user.id) {
			this.filter = JSON.parse(localStorage.getItem('filter-property')).filter;
		} 
		this.startFiltration(this.filter);
	},
	mounted() {
		this.initDropDowns();
		this.$store.dispatch('getAssigned').then((res) => {
			this.DataFiltersModal.DataAssignedAgent.options = res.data;
		});
	},
	computed: {
		properties() {
			return this.$store.getters.getProperties;
		},
		allTotals() {
			return this.$store.getters.getAllTotals;
		},
		propertiesInfinitResult() {
			return this.$store.getters.getPropertiesInfinitResult;
		}
	},
	watch: {
		properties() {
			this.noResults = !this.properties.length;
			this.preloader = false;

			const arr = [];

			this.properties.forEach((ele) => {
				if (ele.listing_status_label === 'In Contract') {
					ele._rowVariant = 'in-contract';
				}
				arr.push(ele);
			});
			this.DashboardPropertiesData.items = arr;					
		}
	},
	methods: {
		formatHeader(header) {
			return header
				.split('_')
				.map(word => word.charAt(0).toUpperCase() + word.slice(1))
				.join(' ');
		},
		exportCSV() {
			const dateColumns = ['created_at', 'updated_at', 'date_verified', 'created_at', 'deleted_at'];
			const reqObj = {
				filter: this.filter,
				order_by: this.localOrderBy.replace('_label', ''),
				order: this.localOrder,
				page: 'csv',
				category: 1,
				isFilter: true
			};
			this.$store.dispatch('fetchProperties', reqObj).then(res => {
				res.data.properties.forEach((property, index) => {
					Object.keys(property).forEach(key => {
						if (key.includes('date_') || dateColumns.includes(key)) {
							property[key] = property[key] ? property[key].split('T')[0] : '';
						}
					});
					let areaLabel = property.area_label;
					if (areaLabel.includes('Near Brooklyn')) {
						areaLabel = areaLabel.filter(label => label.trim() !== 'Near Brooklyn');
						areaLabel.push('New Jersey');
					}
					if (areaLabel.includes('Near Boro Park')) {
						areaLabel = areaLabel.filter(label => label.trim() !== 'Near Boro Park');
						areaLabel.push('Brooklyn');
					}
					property.area_label = areaLabel;

					property.property_type_label.forEach((label, i) => {
						if (label.search('Comunity') > -1) {
							label = label.replace('Comunity', 'Community');
							property.property_type_label[i] = label;
						}
					});
				});
				if (!res.data.properties.length) return;
				const data = res.data.properties;
				const replacer = (key, value) => {
					if (Array.isArray(value)) return value.join(', ');
					return value === null || value === undefined ? '' : value;
				};

				const allKeys = Object.keys(data[0]);
				const headers = allKeys.filter(key => !key.endsWith('_label'));
				const formattedHeaders = headers.map(this.formatHeader);
				const csv = [
					formattedHeaders.join(','),
					...data.map(row =>
						headers.map(field =>
							JSON.stringify(replacer(field, row[field]))
						).join(',')
					)
				].join('\n');

				const blob = new Blob([csv], { type: 'text/csv' });
				const url = URL.createObjectURL(blob);
				const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
				const filename = `export-${timestamp}.csv`;

				const a = document.createElement('a');
				a.href = url;
				a.download = filename;
				a.style.display = 'none';

				document.body.appendChild(a);
				a.click();
				document.body.removeChild(a);
				URL.revokeObjectURL(url);
			});
		},
		// Property History only for published properties
		PropertyHistoryOrEdit(id, target) {
			if (!this.checkPermissions()) {
				const routePropertyHistoryOrEdit = this.$router.resolve({ name: 'PropertyHistoryAdmin', params: { id: id } });
				window.open(routePropertyHistoryOrEdit.href, target);
			}
		},
		historyRow(id) {
			this.showPopupTable = true;
			this.$parent.$refs.app.parentNode.classList.add(this.classScroll);
			this.$store.dispatch('fetchProperty', id).then(response => {
				this.DataPopupPropertyHistory.DataMatchCustomer.items = response.data.history;
				this.DataPopupPropertyHistory.propertyName = response.data.property.title;
				this.DataPopupPropertyHistory.propertyCreated = response.data.property.created_at;
			});
		},
		closePopupPropertyHistory() {
			this.showPopupTable = false;
			this.$parent.$refs.app.parentNode.classList.remove(this.classScroll);
			this.DataPopupPropertyHistory.DataMatchCustomer.items = [];
			this.DataPopupPropertyHistory.propertyName = '';
			this.DataPopupPropertyHistory.propertyCreated = '';
		},
		updateHistoryTable(id) {
			this.$store.dispatch('fetchProperty', id).then(response => {
				this.DataPopupPropertyHistory.DataMatchCustomer.items = response.data.history;
			});
		},
		removeRow(id) {
			const index = this.DashboardPropertiesData.items.findIndex(i => i.id === id);
			this.DashboardPropertiesData.items.splice(index, 1);
		},
		deleteProperty(id) {
			this.$store.dispatch('deleteProperty', id).then(response => {
				this.allTotals.total_active = response.data.total_active;
				this.allTotals.total_draft = response.data.total_draft;
				this.allTotals.total_deleted = response.data.total_deleted;
				this.removeRow(id);
				if (undefined !== response.data) {
					this.notification(response);
				}
			});
		},
		notification(response) {
			this.notificationsData.msg = response.data.message;
			this.notificationsData.type = response.status === 200 ? 'success' : 'danger';

			setTimeout(() => {
				this.notificationsData.msg = '';
				this.notificationsData.type = '';
			}, 2000);
		},
		deleteRow(id) {
			this.showPopupDelete = true;
			this.PopupDelete.itemID = id;
			this.$parent.$refs.app.parentNode.classList.add(this.classScroll);
		},
		editRow(id, target) {
			const routeEdit = this.$router.resolve({ name: 'EditProperty', params: { id: id } });
			window.open(routeEdit.href, target);
		},
		closePopupDelete() {
			this.showPopupDelete = false;
			this.$parent.$refs.app.parentNode.classList.remove(this.classScroll);
		},
		confirmPopupDelete(id) {
			this.deleteProperty(id);
			this.showPopupDelete = false;
			this.$parent.$refs.app.parentNode.classList.remove(this.classScroll);
		},
		async getPage() {
			// check if false (agent) else (admin)
			const adminOrAgent = this.propertiesInfinitResult;
			
			let nextPage = adminOrAgent.current_page++;
			(adminOrAgent.current_page === 0)
				? nextPage = 1
				: nextPage = adminOrAgent.current_page++;
			if (this.infinitScrollFlag || nextPage > adminOrAgent.last_page || this.preventGetPage === true) {
				return false;
			}

			this.infinitScrollFlag = true;
			const obj = {
				order_by: this.localOrderBy.replace('_label', ''),
				order: this.localOrder,
				page: nextPage,
				filter: this.filter,
				isFilter: false
			};
			this.preloader = true;
			this.$store.dispatch('fetchProperties', obj).then(response => {
				response.data.properties.forEach(property => {
					if (property.area_label.includes('Near Boro Park')) {
						property.area_label = ['Brooklyn'];
					}

					if (property.area_label.includes('Near Brooklyn')) {
						property.area_label = ['New Jersey'];
					}

					property.property_type_label.forEach((label, i) => {
						if (label.search('Comunity') > -1) {
							label = label.replace('Comunity', 'Community');
							property.property_type_label[i] = label;
						}
					});
				});
				this.preloader = false;
				this.infinitScrollFlag = false;
			});
		},
		fetchNewActiveProperties(obj) {
			this.preloader = true;
			// TODO: fix pagination when implemented
			return this.$store.dispatch('fetchProperties', obj);
		},
		sortProperties(item) {
			this.preventGetPage = true;
			this.DashboardPropertiesData.items = [];
			const obj = {
				order_by: item.replace('_label', ''),
				order: this.SortOrder(item),
				page: 1,
				filter: this.filter,
				isFilter: true
			};
			this.localOrderBy = item;
			this.fetchNewActiveProperties(obj).then(response => {
				response.data.properties.forEach(property => {
					if (property.area_label.includes('Near Boro Park')) {
						property.area_label = ['Brooklyn'];
					}

					if (property.area_label.includes('Near Brooklyn')) {
						property.area_label = ['New Jersey'];
					}

					property.property_type_label.forEach((label, i) => {
						if (label.search('Comunity') > -1) {
							label = label.replace('Comunity', 'Community');
							property.property_type_label[i] = label;
						}
					});
				});
				this.preventGetPage = false;
			});
		},
		SortOrder(item) {
			if (this.localOrderBy === item) {
				if (this.localOrder === 'asc') {
					this.localOrder = 'desc';
				} else {
					this.localOrder = 'asc';
				}
			} else {
				this.localOrder = 'asc';
			}
			return this.localOrder;
		},
		startFiltration(filter) {
			if (this.filtrationInProgress) {
				return;
			}
			this.preloader = true;
			this.filtrationInProgress = true;
			this.DashboardPropertiesData.items = [];
			this.filter = filter;
			const obj = {
				filter: this.filter,
				order_by: this.localOrderBy.replace('_label', ''),
				order: this.localOrder,
				page: 1,
				isFilter: true
			};
			// TODO: fix pagination when implemented
			this.$store.dispatch('fetchProperties', obj).then(res => {
				this.allTotals.total_active = res.data.total_active;
				this.allTotals.total_draft = res.data.total_draft;
				this.allTotals.total_deleted = res.data.total_deleted;
				res.data.properties.forEach((property, index) => {
					let areaLabel = property.area_label;
					if (areaLabel.includes('Near Brooklyn')) {
						areaLabel = areaLabel.filter(label => label.trim() !== 'Near Brooklyn');
						areaLabel.push('New Jersey');
					} 
					if (areaLabel.includes('Near Boro Park')) {
						areaLabel = areaLabel.filter(label => label.trim() !== 'Near Boro Park');
						areaLabel.push('Brooklyn');
					} 
					property.area_label = areaLabel;

					property.property_type_label.forEach((label, i) => {
						if (label.search('Comunity') > -1) {
							label = label.replace('Comunity', 'Community');
							property.property_type_label[i] = label;
						}
					});
					this.preloader = false;
				});
				this.filtrationInProgress = false;
			});
		},
		resetFiltration() {
			if (this.filtrationInProgress) {
				return;
			}
			this.filtrationInProgress = true;
			this.preloader = true;
			this.DashboardPropertiesData.items = [];
			this.filter = {};
			this.localOrder = this.defaultOrder;
			this.localOrderBy = this.defaultOrderBy;
			const obj = {
				order_by: this.localOrderBy.replace('_label', ''),
				order: this.localOrder,
				page: 1,
				isFilter: true
			};
			// TODO: fix pagination when implemented
			this.$store.dispatch('fetchProperties', obj).then(response => {
				response.data.properties.forEach((property, index) => {
					let areaLabel = property.area_label;
					if (areaLabel.includes('Near Brooklyn')) {
						areaLabel = areaLabel.filter(label => label.trim() !== 'Near Brooklyn');
						areaLabel.push('New Jersey');
					} 
					if (areaLabel.includes('Near Boro Park')) {
						areaLabel = areaLabel.filter(label => label.trim() !== 'Near Boro Park');
						areaLabel.push('Brooklyn');
					} 
					property.area_label = areaLabel;

					property.property_type_label.forEach((label, i) => {
						if (label.search('Comunity') > -1) {
							label = label.replace('Comunity', 'Community');
							property.property_type_label[i] = label;
						}
					});
				});
				this.preloader = false;
				this.filtrationInProgress = false;
			});
			this.initDropDowns();
		},
		initDropDowns() {
			const dropFields = ['offering_types', 'areas', 'property_filter', 'listing_status', 'listing_type'];
			const user = JSON.parse(localStorage.getItem('user'));
			const savedFilters = localStorage.getItem('filter-property') ? (JSON.parse(localStorage.getItem('filter-property')).user_id === user.id ? JSON.parse(localStorage.getItem('filter-property')).filter : []) : [];	
			this.$store.dispatch('fetchDropDownOptions', { values: dropFields }).then((res) => {
				const data = res.data;
				this.DataFiltersModal.DataOfferingType.options = data.offering_types;
				this.DataFiltersModal.DataArea.options = data.areas;
				this.DataFiltersModal.DataPropertyType.options = data.property_filter;
				if (savedFilters && savedFilters.listing_status) {
					data.listing_status.forEach((list, index) => {
						if (savedFilters.listing_status.includes(list.id)) {
							data.listing_status[index].checked = true;
						}
					});
				}
				this.DataFiltersModal.DataListingStatus.lists = data.listing_status;
				if (savedFilters && savedFilters.listing_type) {
					data.listing_type.forEach((list, index) => {
						if (savedFilters.listing_type.includes(list.id)) {
							data.listing_type[index].checked = true;
						}
					});
				}
				this.DataFiltersModal.DataListingType.lists = data.listing_type;
			});
		},
		cloneProperty(id) {
			this.$router.push({ name: 'CloneProperty', params: { id: id } });
		},
		checkPermissions() {
			return check();
		}
	}
};
</script>
<style lang="scss" scoped>
.dashborad-properies-wrap {
	padding-top: 29px;
}

.dashborad-properies-wrap-title {
	display: flex;
	align-items: center;
	margin-bottom: 29px;
	position: relative;
	flex-wrap: wrap;

	@include mq($md) {
		flex-direction: column;
	}
}

.dashborad-properies-wrap-title-box {
	display: flex;
	align-items: center;
	position: relative;
	justify-content: space-between;
	width: 100%;

	@include mq($sm) {
		justify-content: space-between;
		width: 100%;
	}
}

.dashborad-properies-wrap__icon-plus {
	margin-right: 5px;
	font-size: 14px;
	height: 17px;

	svg {
		height: 14px;
	}
}

.page-properties {
	max-width: 100%;
	width: 100%;
	padding: 20px 35px 43px 0;

	@include mq(1200px) {
		max-width: 100%;
		padding: 20px 15px;
	}

	@include mq($xl) {
		padding: 20px 0;
	}
}

.dashborad-properies-table {
    max-width: 100%;
	margin: -1px 0;
}

.section-title--dashborad-properies {
	margin: 0 24px 0 2px;
	white-space: nowrap;
}

.dashboard-properties-wrap__header {
	display: flex;
	margin: 0;
	width: 100%;
	justify-content: space-around;
}

.dashboard-properties-wrap__header-link {
	font-family: $font-main;
	font-weight: 500;
	font-size: 16px;
	line-height: 24px;
	text-align: center;
	color: $shuttle-gray;
	display: flex;
    justify-content: center;
    align-items: center;
    padding: 13px;
	transition: $dur $ease;
	text-decoration: none;
	max-width: 33.3%;
	flex: 0 0 33.3%;
	width: 100%;
	position: relative;
	background-color: $white-lilac;

	@include mq($md) {
		font-size: 14px;
	}

	@include mq(670px) {
		padding: 10px;
		flex-direction: column;
	}

	&::after {
		content: '';
		position: absolute;
		top: 0;
		right: 0;
		background-color: $selago;
		width: 1px;
		height: 100%;
		opacity: 0.4;
		transition: $dur $ease;
	}

	&:first-of-type {
		border-top-left-radius: 14px;
	}

	&:last-of-type {
		border-top-right-radius: 14px;
		&::after {
			display: none;
		}
	}

	&.is-active-link {
		background-color: $link-water;
		color: $dodger-blue;
	}

	@include hover {
		background-color: $link-water;
		color: $dodger-blue;
	}
}

.dashboard-properties-wrap__icon {
	display: inline-block;
    padding-right: 7px;
	font-size: 14px;
	height: 20px;

	@include mq(670px) {
		display: none;
	}

	svg {
		display: block;
		height: 14px;
	}
}

.dashboard-properties-wrap__icon--list {
	font-size: 11px;
	height: 20px;
}

.dashboard-properties-wrap__header-inner {
	@include mq(670px) {
		flex-direction: column;
		display: flex;
	}
}
.dashboard-properties-btn-wrap {
	width: 160px;
}
</style>
